export default {"src":"/_next/static/media/card-progress-tracking.72ce697b.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};